import md5 from "crypto-js/md5";
import hmacSHA256 from "crypto-js/hmac-sha256";

import http from "Http";

export default {
	init() {
		const token = sessionStorage.getItem("rec.auth.token");

		if (token === null) {
			this.redirect();
			// throw error to stop further script execution after redirect
			throw new Error("Not authenticated, redirect to login");
		}

		// Set authentication token from session storage to http header
		this.setToken(token);

		// Set global http redirect to login page on error 401
		http.interceptors.response.use(null, (error) => {
			if (error.response && error.response.status === 401)
				this.redirect();

			return Promise.reject(error);
		});
	},
	redirect() {
		const currentPath = location.pathname + location.search + location.hash;

		if (currentPath === "/")
			location.href = "/login";
		else
			location.href = `/login?target=${encodeURIComponent(currentPath)}`;
	},
	clearToken() {
		delete http.defaults.headers.common.Authorization;
		sessionStorage.removeItem("rec.auth.token");
	},
	setToken(token) {
		http.defaults.headers.common.Authorization = "Bearer " + token;
	},
	login(username, password, ts = null) {
		const passhash = md5(`${username.toLowerCase()}:this-is-realm:${password}`).toString();
		const requestData = {};

		requestData.username = username;
		requestData.expires = Math.floor((ts || Date.now()) / 1000) + 3600;
		requestData.signature = hmacSHA256(username + requestData.expires, passhash).toString();

		return http.post("/api/v2/token", requestData)
		.then((response) => {
			const token = response.data.access_token;

			this.setToken(token);
			sessionStorage.setItem("rec.auth.token", token);

			return response;
		})
		.catch((error) => {
			if (error.response && error.response.status === 400 && !ts) {
				ts = new Date(error.response.headers.date).getTime();

				console.log("retry using server time", ts);

				return this.login(username, password, ts);
			}

			this.clearToken();

			return Promise.reject(error);
		});
	},
	logout(origin="/") {
		this.clearToken();

		location.href = `/logout?origin=${encodeURIComponent(origin)}`;
	}
};
